var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 67,
    viewBox: "0 0 94 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1705_2773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7615 65.6598L77.5851 43.2173L78.5115 41.2962H76.375H54.2179V1.33984H92.6572V42.3306L81.406 65.6598H66.7615ZM13.8865 65.6598L24.7101 43.2173L25.6365 41.2962H23.5H1.3429V1.33984H39.7822V42.3306L28.5311 65.6598H13.8865Z",
    stroke: "#A8A8A8",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1705_2773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0ad94fee96ecbe3ea8efb85bac7b1da6.svg";
export { ForwardRef as ReactComponent };